import { Component, computed, input } from "@angular/core";

export type RatetableActionMap = {
  [key in RatetableItem]?: Function;
};

type RatetableAction = {
  icon: string;
  title: string;
  actionFn: Function;
  visible?: boolean;
};

type RatetableBaseAction = Pick<RatetableAction, "title" | "icon"> & {
  type: RatetableItem;
};

export enum RatetableItem {
  SERVICE = "service",
  DRUG = "drug",
  PARAPHARMACEUTICAL = "parapharmaceutical",
  PRODUCT = "product"
}

@Component({
  selector: "snt-ratetable-toolbar",
  templateUrl: "./ratetable-toolbar.component.html",
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ],
  standalone: false
})
export class RatetableToolbarComponent {
  private readonly BASE_ACTIONS: RatetableBaseAction[] = [
    {
      icon: "fa-file-medical",
      title: "Aggiungi prestazione",
      type: RatetableItem.SERVICE
    },
    {
      icon: "fa-pills",
      title: "Aggiungi farmaco",
      type: RatetableItem.DRUG
    },
    {
      icon: "fa-prescription-bottle",
      title: "Aggiungi parafarmaco",
      type: RatetableItem.PARAPHARMACEUTICAL
    },
    {
      icon: "fa-list",
      title: "Aggiungi prodotto",
      type: RatetableItem.PRODUCT
    }
  ];

  actionsMap = input.required<RatetableActionMap>();

  customActions = input<RatetableAction[]>([]);

  addItemActionButtonList = computed<RatetableAction[]>(() => {
    let map = this.actionsMap();
    let customActions = this.customActions();
    let baseActions: RatetableBaseAction[] = this.BASE_ACTIONS;

    let actions: RatetableBaseAction[] | RatetableAction[] = baseActions;

    actions = actions
      .filter(({ type }) => Object.keys(map).includes(type))
      .map<RatetableAction>(({ icon, title, type }) => {
        let actionFn: Function = map[type]!;

        return <RatetableAction>{ icon, title, actionFn };
      });

    if (customActions.length > 0) {
      actions = [...actions, ...customActions];
    }

    return actions;
  });
}
